<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="w-160" v-if="showDept">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDept"
        @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.isBooked"
        placeholder="是否预约"
      >
        <el-option
          v-for="(item, i) in orderData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.isStudied"
        placeholder="是否学习"
      >
        <el-option
          v-for="(item, i) in studyData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn" style="width: 150px">
      <el-select
        class="select_btn_style"
        v-model="filters.isCreditEarned"
        placeholder="是否获得学时"
      >
        <el-option
          v-for="(item, i) in isGetCreditData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="姓名/手机号"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree ref="singleCheckTree" @deptSelected="deptSelected" showTooltip/>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import SingleCheckTree from "@/components/tree/singleCheckTreeNew";
export default {
  components: {
    butn, SingleCheckTree
  },
  data() {
    return {
      orderData: [
        {paramValue: "全部", paramKey: ''},
        {paramValue: "已预约", paramKey: '1'},
        {paramValue: "未预约", paramKey: '0'}
      ],
      studyData: [
        {paramValue: "全部", paramKey: ''},
        {paramValue: "已学习", paramKey: '1'},
        {paramValue: "未学习", paramKey: '0'}
      ],
      isGetCreditData: [
        {paramValue: "全部", paramKey: ''},
        {paramValue: "已获得学时", paramKey: '1'},
        {paramValue: "未获得学时", paramKey: '0'}
      ],
      filters: {
        name: '',
      },
      deptName: '',
      selectDeptIds: [],
    };
  },
  props: {

  },
  created() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {

    showDept() {
      this.$refs.singleCheckTree.show(this.selectDeptIds);
    },

    deptSelected(dept) {
      this.deptName = dept.deptName;
      this.selectDeptIds = [dept.uuid];
      this.filters = {
        ...this.filters,
        deptLevelCodeQuery: dept.deptLevelCode,
      };
    },

    clearDepts() {
      this.deptName = '';
      this.selectDeptIds = [];
      this.filters.deptLevelCodeQuery = '';
    },

    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.clearDepts();
      this.filters = {
        name: '',
      };
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
